export const appPaths = {
  home: "/",
  user: "/me",
  userFavorites: "/me/favorites",
  userUpcoming: "/me/upcoming",
  register: "/register",
  login: "/login",
  logout: "/logout",
};
